import { Injectable } from '@angular/core'
import { TaskSettings } from '@awork/features/task/models/task-settings.model'
import { SignalStore } from '@awork/core/state/signal-store/signalStore'

@Injectable({ providedIn: 'root' })
export class TaskSettingsStore extends SignalStore<TaskSettings> {
  constructor() {
    super({ name: 'taskSettings', initialState: new TaskSettings(null) })
  }
}
